declare namespace $ {

	type $shm_wordstat_filter_panel__state_shm_wordstat_dashboard_1 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['state'] >
		,
		ReturnType< $shm_wordstat_filter_panel['state'] >
	>
	type $shm_wordstat_filter_panel__title_content_shm_wordstat_dashboard_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_panel['title_content'] >
	>
	type $shm_wordstat_filter_panel__tools_shm_wordstat_dashboard_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_panel['tools'] >
	>
	type $shm_wordstat_filter_panel__collecting_shm_wordstat_dashboard_4 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_filter_panel['collecting'] >
	>
	type $shm_wordstat_filter_panel__query_visible_shm_wordstat_dashboard_5 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_filter_panel['query_visible'] >
	>
	type $shm_wordstat_filter_panel__query_limit_shm_wordstat_dashboard_6 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['query_limit'] >
		,
		ReturnType< $shm_wordstat_filter_panel['query_limit'] >
	>
	type $shm_wordstat_filter_panel__queries_blur_shm_wordstat_dashboard_7 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_title_from_query'] >
		,
		ReturnType< $shm_wordstat_filter_panel['queries_blur'] >
	>
	type $shm_wordstat_filter_panel__period_kind_available_shm_wordstat_dashboard_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_panel['period_kind_available'] >
	>
	type $shm_wordstat_filter_panel__period_kind_visible_shm_wordstat_dashboard_9 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_filter_panel['period_kind_visible'] >
	>
	type $shm_wordstat_filter_panel__device_visible_shm_wordstat_dashboard_10 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_filter_panel['device_visible'] >
	>
	type $shm_wordstat_filter_panel__region_available_shm_wordstat_dashboard_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_wordstat_filter_panel['region_available'] >
	>
	type $shm_wordstat_filter_panel__region_visible_shm_wordstat_dashboard_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_wordstat_filter_panel['region_visible'] >
	>
	type $shm_wordstat_filter_panel__run_enabled_shm_wordstat_dashboard_13 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run_enabled'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run_enabled'] >
	>
	type $shm_wordstat_filter_panel__run_title_shm_wordstat_dashboard_14 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run_title'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run_title'] >
	>
	type $shm_wordstat_filter_panel__run_shm_wordstat_dashboard_15 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run'] >
	>
	type $mol_view__attr_shm_wordstat_dashboard_16 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_wordstat_dashboard['collects_title'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_wordstat_dashboard_18 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_wordstat_dashboard['quota_title'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__title_shm_wordstat_dashboard_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_wordstat_dashboard_21 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_box__title_shm_wordstat_dashboard_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_dashboard_23 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['regular_daily'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_table__table_shm_wordstat_dashboard_26 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collect_items_table'] >
		,
		ReturnType< $shm_wordstat_table['table'] >
	>
	type $mol_button_minor__title_shm_wordstat_dashboard_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__enabled_shm_wordstat_dashboard_28 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['report_send_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_wordstat_dashboard_29 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['report_send'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_check_box__title_shm_wordstat_dashboard_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_wordstat_dashboard_31 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['reports_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__hint_shm_wordstat_dashboard_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_wordstat_dashboard_34 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['telegram_chat_ids_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_wordstat_dashboard_35 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['telegram_chat_ids_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_wordstat_dashboard_36 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_wordstat_dashboard['telegram_chat_ids_commit'] > ): ReturnType< $shm_wordstat_dashboard['telegram_chat_ids_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_wordstat_dashboard_37 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_wordstat_dashboard_38 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['Telegram_chat_ids'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__hint_shm_wordstat_dashboard_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_wordstat_dashboard_40 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['max_chat_ids_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_shm_wordstat_dashboard_41 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['max_chat_ids_commit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_shm_wordstat_dashboard_42 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $shm_wordstat_dashboard['max_chat_ids_commit'] > ): ReturnType< $shm_wordstat_dashboard['max_chat_ids_commit'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_labeler__title_shm_wordstat_dashboard_43 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_wordstat_dashboard_44 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['Max_chat_ids'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_text__text_shm_wordstat_dashboard_46 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['report_error'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_wordstat_dashboard_47 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collect_form_missing_message'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_text__text_shm_wordstat_dashboard_48 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collect_error'] >
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_page__title_content_shm_wordstat_dashboard_49 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collects_title_content'] >
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_wordstat_dashboard_50 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_wordstat_dashboard_51 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collects_body'] >
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_52 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['result_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_wordstat_dashboard_53 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['dashboard_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__title_content_shm_wordstat_dashboard_54 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['title_content'] >
	>
	type $mol_page__tools_shm_wordstat_dashboard_55 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['report_tools'] >
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_wordstat_dashboard_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_wordstat_filter_panel__state_shm_wordstat_dashboard_57 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['filter_state'] >
		,
		ReturnType< $shm_wordstat_filter_panel['state'] >
	>
	type $shm_wordstat_filter_panel__period_all_kind_shm_wordstat_dashboard_58 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['period_all_kind'] >
		,
		ReturnType< $shm_wordstat_filter_panel['period_all_kind'] >
	>
	type $shm_wordstat_filter_panel__collecting_shm_wordstat_dashboard_59 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collecting'] >
		,
		ReturnType< $shm_wordstat_filter_panel['collecting'] >
	>
	type $shm_wordstat_filter_panel__query_visible_shm_wordstat_dashboard_60 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['query_filter_visible'] >
		,
		ReturnType< $shm_wordstat_filter_panel['query_visible'] >
	>
	type $shm_wordstat_filter_panel__query_available_shm_wordstat_dashboard_61 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['query_available'] >
		,
		ReturnType< $shm_wordstat_filter_panel['query_available'] >
	>
	type $shm_wordstat_filter_panel__period_kind_available_shm_wordstat_dashboard_62 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['period_kind_available'] >
		,
		ReturnType< $shm_wordstat_filter_panel['period_kind_available'] >
	>
	type $shm_wordstat_filter_panel__period_kind_visible_shm_wordstat_dashboard_63 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['period_kind_filter_visible'] >
		,
		ReturnType< $shm_wordstat_filter_panel['period_kind_visible'] >
	>
	type $shm_wordstat_filter_panel__device_visible_shm_wordstat_dashboard_64 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['device_filter_visible'] >
		,
		ReturnType< $shm_wordstat_filter_panel['device_visible'] >
	>
	type $shm_wordstat_filter_panel__device_available_shm_wordstat_dashboard_65 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['device_available'] >
		,
		ReturnType< $shm_wordstat_filter_panel['device_available'] >
	>
	type $shm_wordstat_filter_panel__region_available_shm_wordstat_dashboard_66 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['region_available'] >
		,
		ReturnType< $shm_wordstat_filter_panel['region_available'] >
	>
	type $shm_wordstat_filter_panel__region_visible_shm_wordstat_dashboard_67 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['region_filter_visible'] >
		,
		ReturnType< $shm_wordstat_filter_panel['region_visible'] >
	>
	type $shm_wordstat_filter_panel__period_all_shm_wordstat_dashboard_68 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['period_all'] >
		,
		ReturnType< $shm_wordstat_filter_panel['period_all'] >
	>
	type $shm_wordstat_filter_panel__run_enabled_shm_wordstat_dashboard_69 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run_enabled'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run_enabled'] >
	>
	type $shm_wordstat_filter_panel__run_title_shm_wordstat_dashboard_70 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run_title'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run_title'] >
	>
	type $shm_wordstat_filter_panel__run_shm_wordstat_dashboard_71 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['run'] >
		,
		ReturnType< $shm_wordstat_filter_panel['run'] >
	>
	type $mol_view__sub_shm_wordstat_dashboard_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_wordstat_table__table_shm_wordstat_dashboard_73 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['query_summary'] >
		,
		ReturnType< $shm_wordstat_table['table'] >
	>
	type $shm_wordstat_table__table_shm_wordstat_dashboard_74 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['query_table'] >
		,
		ReturnType< $shm_wordstat_table['table'] >
	>
	type $shm_wordstat_chart_timeseries__rows_shm_wordstat_dashboard_75 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['chart_timeseries'] >
		,
		ReturnType< $shm_wordstat_chart_timeseries['rows'] >
	>
	type $shm_wordstat_chart_timeseries__period_kind_shm_wordstat_dashboard_76 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['period_kind'] >
		,
		ReturnType< $shm_wordstat_chart_timeseries['period_kind'] >
	>
	type $shm_wordstat_chart_timeseries__period_range_pick_shm_wordstat_dashboard_77 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['chart_period_range_pick'] >
		,
		ReturnType< $shm_wordstat_chart_timeseries['period_range_pick'] >
	>
	type $shm_wordstat_chart_timeseries__rendered_shm_wordstat_dashboard_78 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['chart_rendered'] >
		,
		ReturnType< $shm_wordstat_chart_timeseries['rendered'] >
	>
	type $shm_service_task_menu__remove_shm_wordstat_dashboard_79 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_delete'] >
		,
		ReturnType< $shm_service_task_menu['remove'] >
	>
	type $shm_service_dashboard_head__title_shm_wordstat_dashboard_80 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_title_draft'] >
		,
		ReturnType< $shm_service_dashboard_head['title'] >
	>
	type $shm_service_dashboard_head__title_save_shm_wordstat_dashboard_81 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_title_commit'] >
		,
		ReturnType< $shm_service_dashboard_head['title_save'] >
	>
	type $shm_service_dashboard_head__title_keydown_shm_wordstat_dashboard_82 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_title_keydown'] >
		,
		ReturnType< $shm_service_dashboard_head['title_keydown'] >
	>
	type $shm_service_dashboard_head__menu_shm_wordstat_dashboard_83 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['Settings'] >
		,
		ReturnType< $shm_service_dashboard_head['menu'] >
	>
	type $shm_service_dashboard_head__edit_shm_wordstat_dashboard_84 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_edit'] >
		,
		ReturnType< $shm_service_dashboard_head['edit'] >
	>
	type $shm_service_dashboard_head__view_shm_wordstat_dashboard_85 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_view'] >
		,
		ReturnType< $shm_service_dashboard_head['view'] >
	>
	type $shm_service_dashboard_head__view_visible_shm_wordstat_dashboard_86 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_view_enabled'] >
		,
		ReturnType< $shm_service_dashboard_head['view_visible'] >
	>
	type $shm_service_dashboard_head__view_enabled_shm_wordstat_dashboard_87 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_view_enabled'] >
		,
		ReturnType< $shm_service_dashboard_head['view_enabled'] >
	>
	type $shm_service_dashboard_head__edit_color_shm_wordstat_dashboard_88 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_edit_color'] >
		,
		ReturnType< $shm_service_dashboard_head['edit_color'] >
	>
	type $shm_service_dashboard_head__view_color_shm_wordstat_dashboard_89 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode_view_color'] >
		,
		ReturnType< $shm_service_dashboard_head['view_color'] >
	>
	type $mol_button_download__title_shm_wordstat_dashboard_90 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_download['title'] >
	>
	type $mol_button_download__blob_shm_wordstat_dashboard_91 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['csv_blob'] >
		,
		ReturnType< $mol_button_download['blob'] >
	>
	type $mol_button_download__file_name_shm_wordstat_dashboard_92 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['csv_file_name'] >
		,
		ReturnType< $mol_button_download['file_name'] >
	>
	type $shm_wordstat_perf_ready__task_id_shm_wordstat_dashboard_93 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['dashboard_id'] >
		,
		ReturnType< $shm_wordstat_perf_ready['task_id'] >
	>
	type $shm_wordstat_perf_ready__mode_shm_wordstat_dashboard_94 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['task_mode'] >
		,
		ReturnType< $shm_wordstat_perf_ready['mode'] >
	>
	type $shm_wordstat_perf_ready__ready_shm_wordstat_dashboard_95 = $mol_type_enforce<
		ReturnType< $shm_wordstat_dashboard['collect_items_loaded'] >
		,
		ReturnType< $shm_wordstat_perf_ready['ready'] >
	>
	export class $shm_wordstat_dashboard extends $shm_service_dashboard {
		query_limit( ): number
		task_title_from_query( next?: any ): any
		run_enabled( ): boolean
		run_title( ): string
		run( next?: any ): any
		Collect_page( ): $shm_wordstat_filter_panel
		collects_title( ): string
		Collects_title( ): $mol_view
		quota_title( ): string
		Collects_quota( ): $mol_view
		cancel( next?: any ): any
		Collect_cancel( ): $mol_button_minor
		collects_title_content( ): readonly(any)[]
		regular_daily( next?: boolean ): boolean
		Collect_regular( ): $mol_check_box
		Collect_regular_hint( ): $mol_view
		Collect_regular_row( ): $mol_view
		collect_items_table( ): any
		Collect_items_table( ): $shm_wordstat_table
		report_send_enabled( ): boolean
		report_send( next?: any ): any
		Report_send( ): $mol_button_minor
		reports_enabled( next?: boolean ): boolean
		Reports_enabled( ): $mol_check_box
		Reports_actions( ): $mol_view
		telegram_chat_ids_draft( next?: string ): string
		telegram_chat_ids_commit( next?: any ): any
		Telegram_chat_ids( ): $mol_string
		Telegram_chat_ids_label( ): $mol_labeler
		max_chat_ids_draft( next?: string ): string
		max_chat_ids_commit( next?: any ): any
		Max_chat_ids( ): $mol_string
		Max_chat_ids_label( ): $mol_labeler
		Reports_row( ): $mol_view
		report_error( ): string
		Report_error( ): $mol_text
		collect_form_missing_message( ): string
		Collect_empty( ): $mol_text
		collect_error( ): string
		Collect_error( ): $mol_text
		collects_body( ): readonly(any)[]
		Collects_page( ): $mol_page
		dashboard_title( ): string
		result_rows( ): readonly(any)[]
		Result_panel( ): $mol_view
		Report_page( ): $mol_page
		collecting( ): boolean
		query_filter_visible( ): boolean
		query_available( ): readonly(any)[]
		period_kind_available( ): readonly(any)[]
		period_kind_filter_visible( ): boolean
		device_filter_visible( ): boolean
		device_available( ): readonly(any)[]
		region_available( ): readonly(any)[]
		region_filter_visible( ): boolean
		Filters_page( ): $shm_wordstat_filter_panel
		dashboard_pages( ): readonly(any)[]
		query_summary( ): any
		query_table( ): any
		chart_timeseries( ): readonly(any)[]
		period_kind( ): string
		chart_period_range_pick( next?: any ): any
		chart_rendered( next?: any ): any
		task_delete( next?: any ): any
		task_title_draft( next?: string ): string
		task_title_commit( next?: any ): any
		task_title_keydown( next?: any ): any
		task_mode_edit( next?: any ): any
		task_mode_view( next?: any ): any
		task_mode_edit_color( ): string
		task_mode_view_color( ): string
		csv_blob( ): any
		csv_file_name( ): string
		dashboard_id( ): string
		user_id( ): string
		administrating( ): boolean
		tab_title( ): string
		task_mode( ): string
		task_mode_view_enabled( ): boolean
		task_title( next?: string ): string
		state( ): $shm_wordstat_filter_state_store | null
		filter_state( ): $shm_wordstat_filter_state_store | null
		log( next?: string ): string
		running( next?: boolean ): boolean
		job( next?: any ): any
		data( ): any
		collect_items_loaded( ): boolean
		report_tools( ): readonly(any)[]
		period_all( ): ({ 
			'from': string,
			'to': string,
		}) 
		period_all_kind( id: any): ({ 
			'from': string,
			'to': string,
		}) 
		pages( ): ReturnType< $shm_wordstat_dashboard['dashboard_pages'] >
		Empty( ): $mol_view
		Summary_table( ): $shm_wordstat_table
		Data_table( ): $shm_wordstat_table
		Timeseries_chart( ): $shm_wordstat_chart_timeseries
		Settings( ): $shm_service_task_menu
		Dashboard_head( ): $shm_service_dashboard_head
		Csv_download( ): $mol_button_download
		Load_ready( id: any): $shm_wordstat_perf_ready
	}
	
}

//# sourceMappingURL=dashboard.view.tree.d.ts.map